import React, { createContext, useContext, useState, useEffect } from 'react';

import i18n from '../i18n';

const STORAGE_KEY = 'gp_language';

interface LanguageContextType {
  language: string;
  setLanguage: (lang: string) => void;
  isLanguageFromStorage: boolean;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export function LanguageProvider({ children }: { children: React.ReactNode }) {
  const storedLang = localStorage.getItem(STORAGE_KEY);
  const [language, setLanguageState] = useState<string>(storedLang || 'en');
  const [isLanguageFromStorage, setIsLanguageFromStorage] = useState<boolean>(!!storedLang);

  useEffect(() => {
    if (storedLang) i18n.changeLanguage(storedLang);
  }, []);

  const setLanguage = (lang: string) => {
    setLanguageState(lang);
    setIsLanguageFromStorage(true);
    i18n.changeLanguage(lang);
    localStorage.setItem(STORAGE_KEY, lang);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, isLanguageFromStorage }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage(): LanguageContextType {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
